import { render, staticRenderFns } from "./CourseTypeCollapse.vue?vue&type=template&id=458465ae&scoped=true"
import script from "./CourseTypeCollapse.vue?vue&type=script&lang=js"
export * from "./CourseTypeCollapse.vue?vue&type=script&lang=js"
import style0 from "./CourseTypeCollapse.vue?vue&type=style&index=0&id=458465ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458465ae",
  null
  
)

export default component.exports